export default "__VITE_ASSET__wQFkpw7p__"